import { getBinForMerchant } from '@esentai/core/features/merchants/selectors';
import { connect } from 'react-redux';

import Option from '@/components/AutocompleteBase/Option';

const mapStateToProps = (state, { value }) => ({
  label: getBinForMerchant(state, value),
});

export default connect(mapStateToProps, () => ({}))(Option);
